import { LocaleKeys } from "src/internationalization/CustomIntlProvider";
import { OperatorCode } from "src/types/operator";

export const OPERATOR_CODE_LABELS: { [key in OperatorCode]: LocaleKeys } = {
  equalsCurrent: "general.operator.identifque",
  notEqualCurrent: "general.operator.different",
  empty: "general.operator.isNull",
  nonEmpty: "general.operator.isNotNull",
  greaterThanValue: "general.operator.greaterThan",
  greaterOrEqualThanValue: "general.operator.greaterThanOrEquals",
  lowerThanValue: "general.operator.lessThan",
  lowerOrEqualThanValue: "general.operator.lessThanOrEquals",
  contains: "general.operator.contains",
  notContains: "general.operator.notContains",
  isTrue: "general.operator.isTrue",
  notTrue: "general.operator.isFalse",
  equalsValue: "general.operator.equals",
  notEqualsValue: "general.operator.notEquals",
  equalsProperty: "general.operator.equalsProperty",
  notEqualsProperty: "general.operator.notEqualsProperty",
  greaterThanProperty: "general.operator.greaterThanProperty",
  greaterOrEqualThanProperty: "general.operator.greaterOrEqualThanProperty",
  lowerThanProperty: "general.operator.lowerThanProperty",
  lowerOrEqualThanProperty: "general.operator.lowerOrEqualThanProperty",
  containsProperty: "general.operator.containsProperty",
  notContainsProperty: "general.operator.notContainsProperty",
  in: "general.operator.in",
  notIn: "general.operator.notIn",
};
